import { createFileRoute, redirect } from '@tanstack/react-router';

import * as DataIngestion from '@mint-sdk/api-data-ingestion';
import { z } from 'zod';

const searchSchema = z.object({
  search: z.string().prefault(''),
  pageNumber: z.number().prefault(1),
  itemsPerPage: z.number().prefault(50),
});

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/custom-metrics',
)({
  staleTime: 30 * 1000,
  validateSearch: searchSchema,
  async beforeLoad({ context }) {
    // Import Hub v2 custom metrics are managed in MDM
    const isImportHubV2 = await context.isFlagEnabled(
      '@mint/arm',
      'importHubV2',
    );
    if (isImportHubV2) {
      throw redirect({ to: '/external-data/import-hub' });
    }
  },
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ context: { serviceLocator }, deps, cause }) => {
    if (cause === 'stay') {
      return;
    }

    const queryClient = await serviceLocator.getOrThrowInstance('queryClient');

    const initialQueryOptions =
      DataIngestion.CustomMetrics.getCustomMetricsQueryOptions({
        params: {},
      });
    const activeQueryOptions =
      DataIngestion.CustomMetrics.getCustomMetricsQueryOptions({
        params: {
          search: deps.search.search,
        },
      });

    queryClient.prefetchQuery(initialQueryOptions);
    queryClient.prefetchQuery(activeQueryOptions);
  },
});
